import {Injectable} from '@angular/core';
import {baseFile} from "../models/grantApplication/grantApplicationGetinfoResponse";

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  constructor() { }

  fileArray!: baseFile[];

  setFile(value: baseFile[]){
    this.fileArray = value;
  }

  getFile(): baseFile[]{
    return this.fileArray;
  }
}
